<template>
  <div class="wrap">
    <div class="header-wrap">
      <div class="card-message">
        <div>有效期：{{ cardExpiryDate }}</div>
        <div>(有效期为{{ cardTime }}天)</div>
      </div>
    </div>
    <template>
      <div class="matter-wrap" v-if="xyrMatterUrl">
        <div class="title-wrap">
          <van-image
            :src="require('@/assets/images/benefit-left-star.png')"
            class="icon"
          />
          <div class="title">精选实物权益</div>
          <van-image
            :src="require('@/assets/images/benefit-right-star.png')"
            class="icon"
          />
        </div>
        <div class="list">
          <div class="list-item">
            <div class="list-content">
              <div class="list-main">
                <div class="name">实物权益</div>
              </div>
            </div>
            <div class="list-action" @click="handleToXyrMatter">立即领取</div>
          </div>
        </div>
      </div>
      <BenefitList :benefitList="benefitList" />
    </template>
    <div class="footer">
      <div class="footer-content">
        <div class="order" @click="handleToOrder">
          <svg-icon iconClass="bj-service-hz" class="svg-icon" />我的订单
        </div>
        <div class="line"></div>
        <div class="service" @click="handleToService">
          <svg-icon iconClass="bj-order-hz" class="svg-icon" />客服中心
        </div>
      </div>
      <div class="service-time">
        <p>
          客服电话：
          <a href="tel:400-150-9669">400-150-9669</a
          ><span>(每日7:00-21:00)</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  onMounted,
  ref,
  computed,
  watch,
} from "@vue/composition-api";
import dayjs from "dayjs";

import { useRouter, useStore } from "@/components/use/base";
import { getXyrOutBenefit } from "@/apis/home";

import BenefitList from "../component/benefitList.vue";
import MoreCardLogin from "../component/MoreCardLogin.vue";

export default defineComponent({
  components: {
    BenefitList,
    MoreCardLogin,
  },
  setup() {
    const router = useRouter();
    const store = useStore();

    const benefitList = ref([]);
    const xyrMatterUrl = ref("");

    const isMember = computed(() => {
      return store.state.isMember;
    });

    const namespaceGroup = computed(() => {
      return store.state.namespaceInfo.namespace_group_en;
    });

    const isLogin = computed(() => {
      return !!store.state.token;
    });

    const userInfo = computed(() => store.state.userInfo);

    const cardExpiryDate = computed(() =>
      dayjs(userInfo.value.card_expiry_date?.[0]).format("YYYY.MM.DD")
    );

    const cardTime = computed(() => {
      const start = dayjs(userInfo.value.t_vip_created);
      const end = dayjs(userInfo.value.card_expiry_date?.[0]);
      return end.diff(start, "day") + 1;
    });

    watch(
      () => [isMember.value, isLogin.value],
      ([newVal, isLogin]) => {
        if (!newVal || !isLogin) {
          router.replace(
            `/commonLogin?namespace_group=${namespaceGroup.value}`
          );
        }
      },
      { deep: true, immediate: true }
    );

    onMounted(async () => {
      await initData();
    });

    const handleToXyrMatter = () => {
      window.location.href = xyrMatterUrl.value;
    };

    const initData = async () => {
      const { data: xyrData } = await getXyrOutBenefit();
      xyrMatterUrl.value = xyrData.url;
    };

    const handleToOrder = () => {
      router.push("/order");
    };

    const handleToService = () => {
      router.push("/service");
    };

    return {
      benefitList,
      cardExpiryDate,
      cardTime,
      xyrMatterUrl,
      handleToOrder,
      handleToService,
      handleToXyrMatter,
    };
  },
});
</script>

<style scoped lang="less">
.wrap {
  min-height: 100vh;
  background-color: #fff;
}

.header-wrap {
  width: 375px;
  height: 168px;
  background-image: url("https://common-h5-dev.xiangshuheika.com/static/upload/202603258c80dda805e0b.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;

  .card-message {
    position: absolute;
    left: 44px;
    top: 101px;
    font-weight: 400;
    font-size: 9px;
    color: #b8aba4;
    line-height: 13px;
  }
}

.matter-wrap {
  margin-top: 16px;

  .title-wrap {
    display: flex;
    justify-content: center;
    align-items: center;

    .title {
      font-weight: 600;
      font-size: 16px;
      color: #000000;
      line-height: 22px;
      margin: 0 9px;
    }
    .icon {
      height: 22px;
    }
  }

  .list {
    margin-top: 16px;

    .list-item {
      margin: 0 12px 12px 12px;
      height: 79px;
      background: #fef5f1;
      border-radius: 8px;
      box-sizing: border-box;
      padding: 12px 19px 12px 13px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .list-content {
        display: flex;
        align-items: center;

        .img {
          width: 55px;
          height: 55px;
          border-radius: 8px;
          display: block;
        }
        .list-main {
          margin-left: 11px;

          .name {
            font-weight: 600;
            font-size: 16px;
            color: #000000;
            line-height: 22px;
          }
          .desc {
            margin-top: 9px;
            font-weight: 400;
            font-size: 12px;
            color: #666666;
            line-height: 16px;
          }
        }
      }

      .list-action {
        width: 70px;
        height: 24px;
        background: linear-gradient(
          134deg,
          #483122 0%,
          rgba(18, 0, 0, 0.87) 100%
        );
        border-radius: 13px;

        font-weight: 500;
        font-size: 12px;
        color: #f0dbbc;
        line-height: 24px;
        text-align: center;
      }
    }
  }
}

.footer {
  margin-top: auto;
  padding: 20px 12px;
  .footer-content {
    height: 32px;
    background: #f8f8f8;
    border-radius: 8px;
    display: flex;
    align-items: center;
    font-size: 15px;
    color: #333333;
  }
  .svg-icon {
    font-size: 20px;
    margin-right: 9px;
  }

  .order {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
  }

  .line {
    width: 1px;
    height: 23px;
    background: #e4e4e4;
  }

  .service {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
  }

  .service-time {
    font-weight: 400;
    font-size: 10px;
    color: #666666;
    line-height: 14px;
    text-align: center;
    margin-top: 12px;
    a {
      color: #0170fe;
    }
    p {
      span {
        margin-left: 8px;
        color: #666666;
      }
    }
  }
}
</style>
